import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function BonusLogic() {
  return <section className="w-full py-16 px-6" style={{
    backgroundColor: 'var(--cream)'
  }} data-id="element-134">
      <div className="max-w-2xl mx-auto" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-136">
          <div className="flex items-center gap-2 mb-4" data-id="element-137">
            <span className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-138" />
            <span className="text-sm font-bold tracking-wider uppercase" style={{
            color: 'var(--navy)'
          }} data-id="element-139">
              Bloque 2
            </span>
          </div>
          <h2 className="font-serif text-2xl md:text-3xl mb-6" style={{
          color: 'var(--navy)'
        }} data-id="element-140">
            La lógica de los bonos
          </h2>

          <div className="space-y-6 text-lg leading-relaxed" style={{
          color: 'var(--charcoal)'
        }} data-id="element-141">
            <p className="font-medium" data-id="element-142">
              ¿Por qué incluimos estos 3 bonos gratis con "Reset de Deudas en 14
              Días (USA)"?
            </p>
            <p data-id="element-143">
              Porque el sistema de 14 días funciona mejor cuando las tres fugas
              están cerradas al mismo tiempo.
            </p>

            <ul className="space-y-4" data-id="element-144">
              <li className="flex gap-3" data-id="element-145">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" style={{
                color: 'var(--gold)'
              }} data-id="element-146" />
                <span data-id="element-147">
                  No tiene sentido implementar el Sistema 3 Cortes si hay $150
                  saliendo solos de tu cuenta cada mes en suscripciones
                  olvidadas.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-148">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" style={{
                color: 'var(--gold)'
              }} data-id="element-149" />
                <span data-id="element-150">
                  No tiene sentido tener una plantilla de pagos extra si el
                  gasto impulsivo sigue abriendo deuda nueva mientras cerrás la
                  vieja.
                </span>
              </li>
              <li className="flex gap-3" data-id="element-151">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" style={{
                color: 'var(--gold)'
              }} data-id="element-152" />
                <span data-id="element-153">
                  Y no tiene sentido frenar el gasto si después no tenés un
                  ritual claro para ejecutar pagos extra cada vez que cobrás.
                </span>
              </li>
            </ul>

            <p className="font-bold text-xl mt-8" style={{
            color: 'var(--navy)'
          }} data-id="element-154">
              Los 3 bonos no son relleno. Son las piezas que completan el
              sistema.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}